import React from "react";
import Scrollable from "./shared/Scrollable";

function OperationalServiceCardCollapse({
  title,
  children,
  isParent = false,
  open,
  setOpen,
}) {
  const toggle = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  return (
    <div
      className={`servicecard-collapse-container ${
        isParent ? "parent" : "child"
      }`}
    >
      <button
        type="button"
        className={`servicecard-collapse-header ${open ? "active" : ""}`}
        onClick={toggle}
      >
        <span className="servicecard-collapse-title">{title}</span>
        <span className="servicecard-collapse-arrow">▼</span>
      </button>

      {/* The outer element keeps the open/close animation — that transition is
          on its max-height, so it cannot become the scroll region. The
          scrolling happens inside it instead, which also stops SimpleBar
          measuring while the panel is mid-slide. */}
      <div
        className={`servicecard-collapse-content ${
          open ? "open" : ""
        } ${isParent ? "parent-content" : "child-content"}`}
      >
        <Scrollable className="servicecard-collapse-scroll">
          {children}
        </Scrollable>
      </div>
    </div>
  );
}

export default OperationalServiceCardCollapse;